/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Task_Previous_Activity_LabelInputs */

const en_task_previous_activity_label = /** @type {(inputs: Task_Previous_Activity_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Previous activity ${i?.index}`)
};

const pt_br2_task_previous_activity_label = /** @type {(inputs: Task_Previous_Activity_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atividade anterior ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Previous activity {index}" |
*
* @param {Task_Previous_Activity_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_previous_activity_label = /** @type {((inputs: Task_Previous_Activity_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Previous_Activity_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_previous_activity_label(inputs)
	return pt_br2_task_previous_activity_label(inputs)
});